import { trackAction } from 'app/shared/utils/tracking';
import { SERVICE_CATEGORIES_NAMES } from '../ServicesPanel/services/names/index.names';

export const DealerProfileSettingsTracking = {
  DEALER_LOCATION_SELECTION_CLICK: 'DEALER_LOCATION_SELECTION_CLICK',
  DROPDOWN_CLICK: 'DROPDOWN_CLICK',
  MODAL_DISCARD_CHANGES: 'MODAL_DISCARD_CHANGES',
  MODAL_SUBMIT_CHANGES: 'MODAL_SUBMIT_CHANGES',
  NORMAL_SUBMIT_CHANGES: 'NORMAL_SUBMIT_CHANGES',
  SERVICE_CHECKBOX_CLICK: 'SERVICE_CHECKBOX_CLICK',
  SUBMIT_SUCCESS: 'SUBMIT_SUCCESS',
  TOGGLE_DEALER_PROFILE_SETTINGS_ACCORDION:
    'TOGGLE_DEALER_PROFILE_SETTINGS_ACCORDION',
};

/**
 *
 * used only for tracking
 *
 * @param {import('../ServicesPanel/services/names/index.names').DealerProfileServiceCategoryValue} eventLabel
 * @return {'general_services'|'sales_services'|'repair_services'}
 *
 */
export const mapServiceCategoryToTrackingLabel = category => {
  switch (category) {
    case SERVICE_CATEGORIES_NAMES.GENERAL_SERVICES:
      return 'general_services';
    case SERVICE_CATEGORIES_NAMES.VEHICLE_PURCHASE_SERVICES:
      return 'sales_services';
    case SERVICE_CATEGORIES_NAMES.WORKSHOP_SERVICES:
      return 'repair_services';
    default:
      return '';
  }
};

export const trackDealerProfileSettings = ({
  networkId,
  actionType,
  additionalProps = {},
}) => {
  switch (actionType) {
    case DealerProfileSettingsTracking.DEALER_LOCATION_SELECTION_CLICK:
      trackAction(
        'my_dealer_profile_pages_location_dropdown_selection_click',
        {
          category: 'dealer_portal',
          description:
            'user selects in dropdown a single dealer location for editing Profile Page',
        },
        { network_id: networkId },
      );
      break;
    case DealerProfileSettingsTracking.DROPDOWN_CLICK:
      trackAction(
        'my_dealer_profile_pages_location_dropdown_click',
        {
          category: 'dealer_portal',
          description:
            'user clicks in dealer location drop-down on edit Profile Page site',
        },
        { network_id: networkId },
      );
      break;
    case DealerProfileSettingsTracking.MODAL_DISCARD_CHANGES:
      trackAction(
        'my_dealer_profile_page_discard_button_modal_click',
        {
          category: 'dealer_portal',
          description:
            'user clicks on CTA in modal to discard changes for editing Profile Page',
        },
        { network_id: networkId },
      );
      break;
    case DealerProfileSettingsTracking.MODAL_SUBMIT_CHANGES:
      trackAction(
        'my_dealer_profile_page_cta_modal_click',
        {
          category: 'dealer_portal',
          description:
            'user clicks on main green CTA in modal to save changes for editing Profile Page',
        },
        { network_id: networkId },
      );
      break;
    case DealerProfileSettingsTracking.NORMAL_SUBMIT_CHANGES:
      trackAction(
        'my_dealer_profile_pages_cta_click',
        {
          category: 'dealer_portal',
          description:
            'user clicks on main green CTA on page to save changes for editing Profile Page',
        },
        { network_id: networkId },
      );
      break;
    case DealerProfileSettingsTracking.SERVICE_CHECKBOX_CLICK:
      trackAction(
        'my_dealer_profile_pages_service_checkbox_click',
        {
          category: 'dealer_portal',
          description:
            'user clicks into checkbox to select a service in any of the 3 service tabs (distinguished through event_label)',
        },
        { network_id: networkId, event_label: additionalProps.event_label },
      );
      break;
    case DealerProfileSettingsTracking.SUBMIT_SUCCESS:
      trackAction(
        'my_dealer_profile_pages_cta_success',
        {
          category: 'dealer_portal',
          description:
            'event is fired when changes for editing Profile Page could be saved successfully',
        },
        { network_id: networkId },
      );
      break;

    case DealerProfileSettingsTracking.TOGGLE_DEALER_PROFILE_SETTINGS_ACCORDION:
      trackAction(
        'my_dealer_profile_pages_services_click',
        {
          category: 'dealer_portal',
          description:
            'user clicks to expand/collapse service section for editing Profile Page',
        },
        { network_id: networkId },
      );
      break;

    default:
      return;
  }
};
